import { MINUTES_PER_DAY, wallMinOf } from '@wiztime/core';
import type { RefObject } from 'react';
import { useDayData } from '../DayDataContext';
import { BlockLane } from './BlockLane';
import { TimeAxis } from './TimeAxis';
import styles from './Timeline.module.css';
import { useElementHeight } from './useElementHeight';

/** Fallback lane height before the first measurement (about 26 px per hour). */
const INITIAL_LANE_HEIGHT_PX = 640;

/**
 * Column 1: the 52px time axis and the block lane of one personal day. The lane ref comes from
 * `DayView`, which also measures the lane's width for the overlap column cap (§3.1.4).
 */
export function Timeline({ laneRef }: { laneRef: RefObject<HTMLDivElement | null> }) {
  const measured = useElementHeight(laneRef);
  const laneHeightPx = measured > 0 ? measured : INITIAL_LANE_HEIGHT_PX;
  const { date, settings, now } = useDayData();
  const nowWallMin = wallMinOf(now, date);
  const nowMin =
    nowWallMin >= settings.dayStartMin && nowWallMin < settings.dayStartMin + MINUTES_PER_DAY
      ? nowWallMin
      : null;
  return (
    <div className={styles.timeline} data-testid="timeline">
      <TimeAxis dayStartMin={settings.dayStartMin} laneHeightPx={laneHeightPx} nowMin={nowMin} />
      <BlockLane laneRef={laneRef} laneHeightPx={laneHeightPx} />
    </div>
  );
}
